import React from 'react';

import './ArticleCard.css';

const ArticleCard = ({ title, url, isDisabled, category }) => {
  return (
    <div className={`article-card ${isDisabled ? 'disabled' : ''}`}>
      <div className="article-card-top">
        <span className="article-card-category">{category}</span>
      </div>

      <div className="article-card-content">
        <h3 className="article-card-title">{title || 'Título não disponível'}</h3>
        {isDisabled && <p className="article-card-info">Artigo indisponível</p>}
      </div>

      {!isDisabled && url && (
        <a
          href={url}
          className="article-card-link"
          rel="noopener noreferrer"
          aria-label={`Ler artigo: ${title}`}
        />
      )}
    </div>
  );
};

export default ArticleCard;
